import { AddressDetails } from '@vend/business-components/dist/components/AddressForm/types'
import { AddressTypes } from '@vend/business-components/dist/components/EditCustomerModal/DetailsTab/Address'
import { ApiCustomer } from '@vend/types/customer'
import { FulfilmentDetail } from '../../../../models/fulfilment'

export const getCustomerAddressDetails = (
  customer: ApiCustomer,
  addressType: AddressTypes
): AddressDetails => {
  return {
    address_1: customer[`${addressType}_address_1`] || '',
    address_2: customer[`${addressType}_address_2`] || '',
    suburb: customer[`${addressType}_suburb`] || '',
    city: customer[`${addressType}_city`] || '',
    state: customer[`${addressType}_state`] || '',
    country_id: customer[`${addressType}_country_id`] || '',
    postcode: customer[`${addressType}_postcode`] || '',
  }
}

export const generateAddressDetailsFromCustomer = (customer: ApiCustomer) => {
  return {
    shippingAddress: getCustomerAddressDetails(customer, AddressTypes.Shipping),
    billingAddress: getCustomerAddressDetails(customer, AddressTypes.Billing),
  } as Partial<FulfilmentDetail>
}

export const fillEmptyAddressWithCustomerAddress = (
  customer: ApiCustomer,
  billingAddress?: AddressDetails,
  shippingAddress?: AddressDetails
) => {
  return {
    billingAddress:
      billingAddress ||
      getCustomerAddressDetails(customer, AddressTypes.Billing),
    shippingAddress:
      shippingAddress ||
      getCustomerAddressDetails(customer, AddressTypes.Shipping),
  }
}
